import { extend } from 'umi-request';
import { notification } from 'antd';
// import Cookies from 'js-cookie';

const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。',
};

const errorHandler = error => {
  const { response } = error; // response 可能为undefined

  if (response && response.status) {
    const errorText = codeMessage[response.status] || response.statusText;
    const { status } = response;
    notification.error({
      message: `请求错误 ${status}`,
      description: errorText,
    });
  } else {
    console.log(error);
    notification.error({
      description: '您的网络发生异常，无法连接服务器',
      message: response || 'RequestError',
    });
  }

  return response;
};

const xFetch = extend({
  errorHandler,
  credentials: 'include',
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
  },
});

xFetch.interceptors.response.use((response, options) => {
  if (response && response.status !== 200) {
    const errorText = codeMessage[response.status] || response.statusText;
    return {
      code: response.status,
      msg: errorText,
    };
  }
  return response;
});

/**
 * 
 * @param {*} url 
 * @param {*} options 
 * @returns 
 
const xFetchIE9 = (url, options = {}) => {
  if (window.XDomainRequest) {
    return new Promise((resolve, reject) => {
      const method = options.method || 'POST';
      const timeout = options.timeout || 30000;
      let data = options.body || options.params || options.data || {};

      const XDR = new XDomainRequest();
      XDR.open(method, url);
      XDR.timeout = timeout;
      XDR.onload = () => {
        try {
          const json = JSON.parse(XDR.responseText);
          return resolve(json.data);
        } catch (e) {
          reject(e);
        }
        return reject({});
      };
      XDR.onprogress = () => {};
      XDR.ontimeout = () => reject('XDomainRequest timeout');
      XDR.onerror = () => reject('XDomainRequest error');
      setTimeout(() => {
        XDR.send(data);
      }, 0);
    });
  } else {
    // 
  }
};

const isIE9 =
  navigator.appName == 'Microsoft Internet Explorer' &&
  navigator.appVersion.match(/9./i) == '9.' &&
  !('placeholder' in document.createElement('input')) &&
  !!document.all;

const request = isIE9 ? xFetchIE9 : xFetch;

export default request;

*/
export default xFetch;
